import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, vModelCheckbox as _vModelCheckbox, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "mt-10" }
const _hoisted_2 = { class: "bg-white dark:bg-gray-800 relative shadow-md sm:rounded-lg overflow-hidden" }
const _hoisted_3 = { class: "border-b dark:border-gray-700 mx-4" }
const _hoisted_4 = { class: "flex flex-col-reverse md:flex-row items-center justify-between md:space-x-4 py-3" }
const _hoisted_5 = { class: "w-full lg:w-2/3 flex flex-col space-y-3 md:space-y-0 md:flex-row md:items-center" }
const _hoisted_6 = { class: "w-full md:max-w-sm flex-1 md:mr-4" }
const _hoisted_7 = { class: "w-full md:w-auto flex flex-col md:flex-row mb-3 md:mb-0 items-stretch md:items-center justify-end md:space-x-3 flex-shrink-0" }
const _hoisted_8 = { class: "p-4" }
const _hoisted_9 = { class: "mt-6 grid gap-6 md:grid-cols-2" }
const _hoisted_10 = { class: "mt-2" }
const _hoisted_11 = {
  key: 0,
  class: "text-xs text-gray-600"
}
const _hoisted_12 = {
  key: 1,
  class: "text-xs text-green-700"
}
const _hoisted_13 = {
  key: 2,
  class: "text-xs text-red-600"
}
const _hoisted_14 = {
  key: 3,
  class: "mt-2 h-2 w-full rounded-full bg-gray-200"
}
const _hoisted_15 = {
  key: 4,
  class: "mt-3 text-xs text-gray-600"
}
const _hoisted_16 = {
  key: 5,
  class: "mt-3 text-xs text-red-600"
}
const _hoisted_17 = {
  key: 6,
  class: "mt-3 space-y-2"
}
const _hoisted_18 = ["src"]
const _hoisted_19 = { class: "md:col-span-2" }
const _hoisted_20 = { class: "inline-flex items-center text-sm font-medium text-gray-700" }
const _hoisted_21 = { class: "md:col-span-2" }
const _hoisted_22 = { class: "grid gap-3 sm:grid-cols-2" }
const _hoisted_23 = ["value"]
const _hoisted_24 = { class: "md:col-span-2" }
const _hoisted_25 = { class: "flex items-center" }
const _hoisted_26 = ["disabled"]
const _hoisted_27 = { class: "overflow-x-auto" }
const _hoisted_28 = { class: "w-full text-sm text-left text-gray-500 dark:text-gray-400" }
const _hoisted_29 = { key: 0 }
const _hoisted_30 = { key: 1 }
const _hoisted_31 = { class: "border-b dark:border-gray-600" }
const _hoisted_32 = {
  class: "px-4 py-4 text-sm text-gray-500",
  colspan: "6"
}
const _hoisted_33 = { key: 2 }
const _hoisted_34 = {
  class: "px-4 py-2 font-medium text-gray-900 whitespace-nowrap dark:text-white",
  scope: "row"
}
const _hoisted_35 = { class: "px-4 py-2 whitespace-nowrap" }
const _hoisted_36 = { class: "px-4 py-2 whitespace-nowrap" }
const _hoisted_37 = { class: "px-4 py-2 whitespace-nowrap" }
const _hoisted_38 = { class: "px-4 py-2 whitespace-nowrap" }
const _hoisted_39 = { key: 0 }
const _hoisted_40 = { key: 1 }
const _hoisted_41 = { key: 2 }
const _hoisted_42 = { class: "px-4 py-2 whitespace-nowrap" }
const _hoisted_43 = { class: "flex items-center gap-2" }
const _hoisted_44 = ["onClick"]
const _hoisted_45 = {
  "aria-label": "Table navigation",
  class: "flex flex-col md:flex-row justify-between items-start md:items-center space-y-3 md:space-y-0 p-4"
}
const _hoisted_46 = { class: "text-sm font-normal text-gray-500 dark:text-gray-400" }
const _hoisted_47 = { class: "font-semibold text-gray-900 dark:text-white" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Modal = _resolveComponent("Modal")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[35] || (_cache[35] = _createElementVNode("div", { class: "flex items-center justify-between space-x-4 pt-3" }, [
          _createElementVNode("div", { class: "flex-1 flex items-center space-x-3" }, [
            _createElementVNode("h5", { class: "dark:text-white font-semibold" }, " Events ")
          ])
        ], -1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("form", _hoisted_6, [
              _cache[19] || (_cache[19] = _createElementVNode("label", {
                class: "text-sm font-medium text-gray-900 sr-only dark:text-white",
                for: "event-search"
              }, "Search", -1)),
              _withDirectives(_createElementVNode("input", {
                id: "event-search",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchQuery) = $event)),
                class: "block w-full p-2 pl-2 text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-primary-500 focus:border-primary-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500",
                placeholder: "Search events...",
                type: "search"
              }, null, 512), [
                [_vModelText, _ctx.searchQuery]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("button", {
              class: "flex items-center justify-center text-white bg-black hover:bg-primary-800 focus:ring-4 focus:ring-primary-300 font-medium rounded-lg text-sm px-4 py-2 dark:bg-primary-600 dark:hover:bg-primary-700 focus:outline-none dark:focus:ring-primary-800",
              type: "button",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openModal('newEvent')))
            }, _cache[20] || (_cache[20] = [
              _createElementVNode("svg", {
                class: "h-3.5 w-3.5 mr-2",
                fill: "none",
                height: "12",
                viewBox: "0 0 12 12",
                width: "12",
                xmlns: "http://www.w3.org/2000/svg"
              }, [
                _createElementVNode("path", {
                  d: "M6 0.75V11.25M0.75 6H11.25",
                  stroke: "white",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "stroke-width": "1.5"
                })
              ], -1),
              _createTextVNode(" Add New Event ")
            ])),
            _createVNode(_component_Modal, {
              "is-visible": _ctx.modals.newEvent,
              "modal-id": "newEvent",
              "max-width": "sm:max-w-5xl",
              "onUpdate:isVisible": _cache[18] || (_cache[18] = value => _ctx.modals.newEvent = value)
            }, {
              body: _withCtx(() => [
                _createElementVNode("div", _hoisted_8, [
                  _cache[34] || (_cache[34] = _createElementVNode("div", { class: "flex flex-col items-center justify-center" }, [
                    _createElementVNode("h2", { class: "block text-2xl font-bold text-gray-800" }, " Add New Event "),
                    _createElementVNode("p", { class: "mt-2 text-sm text-gray-600" }, " Create an event for members. ")
                  ], -1)),
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", null, [
                      _cache[21] || (_cache[21] = _createElementVNode("label", { class: "block mb-2 text-sm font-medium text-gray-700" }, "Title", -1)),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.title) = $event)),
                        class: "block w-full rounded-lg border border-gray-300 bg-white p-2.5 text-sm text-gray-900 focus:border-primary focus:ring-primary",
                        placeholder: "Event title",
                        required: "",
                        type: "text"
                      }, null, 512), [
                        [_vModelText, _ctx.form.title]
                      ])
                    ]),
                    _createElementVNode("div", null, [
                      _cache[22] || (_cache[22] = _createElementVNode("label", { class: "block mb-2 text-sm font-medium text-gray-700" }, "Location", -1)),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.location) = $event)),
                        class: "block w-full rounded-lg border border-gray-300 bg-white p-2.5 text-sm text-gray-900 focus:border-primary focus:ring-primary",
                        placeholder: "City, venue, or online",
                        type: "text"
                      }, null, 512), [
                        [_vModelText, _ctx.form.location]
                      ])
                    ]),
                    _createElementVNode("div", null, [
                      _cache[23] || (_cache[23] = _createElementVNode("label", { class: "block mb-2 text-sm font-medium text-gray-700" }, "Date", -1)),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.date) = $event)),
                        class: "block w-full rounded-lg border border-gray-300 bg-white p-2.5 text-sm text-gray-900 focus:border-primary focus:ring-primary",
                        required: "",
                        type: "date"
                      }, null, 512), [
                        [_vModelText, _ctx.form.date]
                      ])
                    ]),
                    _createElementVNode("div", null, [
                      _cache[24] || (_cache[24] = _createElementVNode("label", { class: "block mb-2 text-sm font-medium text-gray-700" }, "Type", -1)),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.type) = $event)),
                        class: "block w-full rounded-lg border border-gray-300 bg-white p-2.5 text-sm text-gray-900 focus:border-primary focus:ring-primary",
                        placeholder: "Breakfast gathering",
                        type: "text"
                      }, null, 512), [
                        [_vModelText, _ctx.form.type]
                      ])
                    ]),
                    _createElementVNode("div", null, [
                      _cache[25] || (_cache[25] = _createElementVNode("label", { class: "block mb-2 text-sm font-medium text-gray-700" }, "Price (GBP)", -1)),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.price) = $event)),
                        class: "block w-full rounded-lg border border-gray-300 bg-white p-2.5 text-sm text-gray-900 focus:border-primary focus:ring-primary",
                        min: "0",
                        placeholder: "250",
                        step: "0.01",
                        type: "number"
                      }, null, 512), [
                        [
                          _vModelText,
                          _ctx.form.price,
                          void 0,
                          { number: true }
                        ]
                      ])
                    ]),
                    _createElementVNode("div", null, [
                      _cache[26] || (_cache[26] = _createElementVNode("label", { class: "block mb-2 text-sm font-medium text-gray-700" }, "Ticket URL", -1)),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.ticketUrl) = $event)),
                        class: "block w-full rounded-lg border border-gray-300 bg-white p-2.5 text-sm text-gray-900 focus:border-primary focus:ring-primary",
                        placeholder: "https://tickets.example.com",
                        type: "url"
                      }, null, 512), [
                        [_vModelText, _ctx.form.ticketUrl]
                      ])
                    ]),
                    _createElementVNode("div", null, [
                      _cache[27] || (_cache[27] = _createElementVNode("label", { class: "block mb-2 text-sm font-medium text-gray-700" }, "Banner Image URL", -1)),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.bannerImageUrl) = $event)),
                        class: "block w-full rounded-lg border border-gray-300 bg-white p-2.5 text-sm text-gray-900 focus:border-primary focus:ring-primary",
                        placeholder: "https://images.example.com/event-banner.jpg",
                        type: "url"
                      }, null, 512), [
                        [_vModelText, _ctx.form.bannerImageUrl]
                      ])
                    ]),
                    _createElementVNode("div", null, [
                      _cache[28] || (_cache[28] = _createElementVNode("label", { class: "block mb-2 text-sm font-medium text-gray-700" }, "Banner Image Upload", -1)),
                      _createElementVNode("input", {
                        accept: "image/*",
                        class: "block w-full rounded-lg border border-gray-300 bg-white p-2.5 text-sm text-gray-900 focus:border-primary focus:ring-primary",
                        type: "file",
                        onChange: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.handleBannerUpload && _ctx.handleBannerUpload(...args)))
                      }, null, 32),
                      _createElementVNode("div", _hoisted_10, [
                        (_ctx.bannerUpload.status === 'uploading')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_11, " Uploading banner... " + _toDisplayString(_ctx.bannerUpload.progress) + "% ", 1))
                          : (_ctx.bannerUpload.status === 'success')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_12, " Banner uploaded successfully. "))
                            : (_ctx.bannerUpload.status === 'error')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(_ctx.bannerUpload.error), 1))
                              : _createCommentVNode("", true),
                        (_ctx.bannerUpload.status === 'uploading')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                              _createElementVNode("div", {
                                class: "h-2 rounded-full bg-black transition-all",
                                style: _normalizeStyle({ width: `${_ctx.bannerUpload.progress}%` })
                              }, null, 4)
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.bannerPreview.status === 'loading')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_15, " Loading banner preview... "))
                          : (_ctx.bannerPreview.status === 'error')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(_ctx.bannerPreview.error), 1))
                            : (_ctx.bannerPreview.status === 'ready')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                  _createElementVNode("img", {
                                    alt: "Banner preview",
                                    class: "w-full rounded-lg border border-gray-200",
                                    src: _ctx.bannerPreview.url
                                  }, null, 8, _hoisted_18),
                                  _createElementVNode("button", {
                                    class: "text-xs font-semibold text-red-600 hover:text-red-700",
                                    type: "button",
                                    onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.removeBanner && _ctx.removeBanner(...args)))
                                  }, " Remove banner ")
                                ]))
                              : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("label", _hoisted_20, [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.form.hidePrice) = $event)),
                          class: "mr-2 h-4 w-4 rounded border-gray-300",
                          type: "checkbox"
                        }, null, 512), [
                          [_vModelCheckbox, _ctx.form.hidePrice]
                        ]),
                        _cache[29] || (_cache[29] = _createTextVNode(" Hide price (show as paid event) "))
                      ])
                    ]),
                    _createElementVNode("div", null, [
                      _cache[30] || (_cache[30] = _createElementVNode("label", { class: "block mb-2 text-sm font-medium text-gray-700" }, "Start Time", -1)),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.form.startTime) = $event)),
                        class: "block w-full rounded-lg border border-gray-300 bg-white p-2.5 text-sm text-gray-900 focus:border-primary focus:ring-primary",
                        type: "time"
                      }, null, 512), [
                        [_vModelText, _ctx.form.startTime]
                      ])
                    ]),
                    _createElementVNode("div", null, [
                      _cache[31] || (_cache[31] = _createElementVNode("label", { class: "block mb-2 text-sm font-medium text-gray-700" }, "End Time", -1)),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.form.endTime) = $event)),
                        class: "block w-full rounded-lg border border-gray-300 bg-white p-2.5 text-sm text-gray-900 focus:border-primary focus:ring-primary",
                        type: "time"
                      }, null, 512), [
                        [_vModelText, _ctx.form.endTime]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_21, [
                      _cache[32] || (_cache[32] = _createElementVNode("label", { class: "block mb-2 text-sm font-medium text-gray-700" }, "Who Should Join", -1)),
                      _createElementVNode("div", _hoisted_22, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.whoShouldJoinOptions, (option) => {
                          return (_openBlock(), _createElementBlock("label", {
                            key: option,
                            class: "flex items-center gap-2 text-sm text-gray-700"
                          }, [
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.form.whoShouldJoin) = $event)),
                              class: "h-4 w-4 rounded border-gray-300",
                              type: "checkbox",
                              value: option
                            }, null, 8, _hoisted_23), [
                              [_vModelCheckbox, _ctx.form.whoShouldJoin]
                            ]),
                            _createTextVNode(" " + _toDisplayString(option), 1)
                          ]))
                        }), 128))
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_24, [
                      _cache[33] || (_cache[33] = _createElementVNode("label", { class: "block mb-2 text-sm font-medium text-gray-700" }, "Description", -1)),
                      _withDirectives(_createElementVNode("textarea", {
                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.form.description) = $event)),
                        class: "block w-full rounded-lg border border-gray-300 bg-white p-2.5 text-sm text-gray-900 focus:border-primary focus:ring-primary",
                        placeholder: "Short summary for members",
                        rows: "3"
                      }, null, 512), [
                        [_vModelText, _ctx.form.description]
                      ])
                    ])
                  ])
                ])
              ]),
              footer: _withCtx(() => [
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("button", {
                    class: "w-full py-3 px-4 inline-flex justify-center items-center gap-x-2 text-sm font-semibold rounded-es-xl border border-transparent bg-gray-100 text-gray-800 hover:bg-gray-200",
                    type: "button",
                    onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.closeModal('newEvent')))
                  }, " Cancel "),
                  _createElementVNode("button", {
                    class: "w-full py-3 px-4 inline-flex justify-center items-center gap-x-2 text-sm font-semibold rounded-ee-xl border border-transparent bg-black text-white hover:bg-gray-700 disabled:opacity-50 disabled:pointer-events-none",
                    type: "button",
                    disabled: _ctx.bannerUpload.status === 'uploading',
                    onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.createEvent && _ctx.createEvent(...args)))
                  }, " Add Event ", 8, _hoisted_26)
                ])
              ]),
              _: 1
            }, 8, ["is-visible"])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_27, [
        _createElementVNode("table", _hoisted_28, [
          _cache[39] || (_cache[39] = _createElementVNode("thead", { class: "text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400" }, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", {
                class: "px-4 py-3",
                scope: "col"
              }, " Title "),
              _createElementVNode("th", {
                class: "px-4 py-3",
                scope: "col"
              }, " Date "),
              _createElementVNode("th", {
                class: "px-4 py-3",
                scope: "col"
              }, " Location "),
              _createElementVNode("th", {
                class: "px-4 py-3",
                scope: "col"
              }, " Type "),
              _createElementVNode("th", {
                class: "px-4 py-3",
                scope: "col"
              }, " Price "),
              _createElementVNode("th", {
                class: "px-4 py-3",
                scope: "col"
              }, [
                _createElementVNode("span", { class: "sr-only" }, "Actions")
              ])
            ])
          ], -1)),
          (_ctx.loading)
            ? (_openBlock(), _createElementBlock("tbody", _hoisted_29, _cache[36] || (_cache[36] = [
                _createElementVNode("tr", { class: "border-b dark:border-gray-600" }, [
                  _createElementVNode("td", {
                    class: "px-4 py-4 text-sm text-gray-500",
                    colspan: "6"
                  }, " Loading events... ")
                ], -1)
              ])))
            : (_ctx.filteredEvents.length === 0)
              ? (_openBlock(), _createElementBlock("tbody", _hoisted_30, [
                  _createElementVNode("tr", _hoisted_31, [
                    _createElementVNode("td", _hoisted_32, _toDisplayString(_ctx.searchQuery ? 'No events match your search.' : 'No events created yet.'), 1)
                  ])
                ]))
              : (_openBlock(), _createElementBlock("tbody", _hoisted_33, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredEvents, (event) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: event._id,
                      class: "border-b dark:border-gray-600 hover:bg-gray-100 dark:hover:bg-gray-700"
                    }, [
                      _createElementVNode("th", _hoisted_34, [
                        _createElementVNode("span", null, _toDisplayString(event.title), 1)
                      ]),
                      _createElementVNode("td", _hoisted_35, _toDisplayString(_ctx.formatDate(event.date)), 1),
                      _createElementVNode("td", _hoisted_36, _toDisplayString(event.location || '—'), 1),
                      _createElementVNode("td", _hoisted_37, _toDisplayString(event.type || '—'), 1),
                      _createElementVNode("td", _hoisted_38, [
                        (event.hidePrice)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_39, "Paid event"))
                          : (typeof event.price === 'number')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_40, "£" + _toDisplayString(_ctx.formatPrice(event.price)), 1))
                            : (_openBlock(), _createElementBlock("span", _hoisted_41, "—"))
                      ]),
                      _createElementVNode("td", _hoisted_42, [
                        _createElementVNode("div", _hoisted_43, [
                          _createVNode(_component_router_link, {
                            class: "flex items-center justify-center w-10 h-10 text-gray-700 bg-white border border-gray-300 rounded-lg md:w-10 focus:outline-none hover:bg-gray-100 hover:text-primary-700 focus:z-10 focus:ring-4 focus:ring-gray-200",
                            to: `/administrator/events/${event._id}`,
                            "aria-label": "Edit event",
                            title: "Edit"
                          }, {
                            default: _withCtx(() => _cache[37] || (_cache[37] = [
                              _createElementVNode("svg", {
                                class: "w-5 h-5",
                                fill: "none",
                                viewBox: "0 0 24 24",
                                xmlns: "http://www.w3.org/2000/svg"
                              }, [
                                _createElementVNode("g", {
                                  id: "SVGRepo_bgCarrier",
                                  "stroke-width": "0"
                                }),
                                _createElementVNode("g", {
                                  id: "SVGRepo_tracerCarrier",
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round"
                                }),
                                _createElementVNode("g", { id: "SVGRepo_iconCarrier" }, [
                                  _createElementVNode("g", null, [
                                    _createElementVNode("g", null, [
                                      _createElementVNode("g", null, [
                                        _createElementVNode("g", null, [
                                          _createElementVNode("g", null, [
                                            _createElementVNode("path", {
                                              d: "M20,16v4a2,2,0,0,1-2,2H4a2,2,0,0,1-2-2V6A2,2,0,0,1,4,4H8",
                                              fill: "none",
                                              stroke: "#000000",
                                              "stroke-linecap": "round",
                                              "stroke-linejoin": "round",
                                              "stroke-width": "2"
                                            }),
                                            _createElementVNode("polygon", {
                                              fill: "none",
                                              points: "12.5 15.8 22 6.2 17.8 2 8.3 11.5 8 16 12.5 15.8",
                                              stroke: "#000000",
                                              "stroke-linecap": "round",
                                              "stroke-linejoin": "round",
                                              "stroke-width": "2"
                                            })
                                          ])
                                        ])
                                      ])
                                    ])
                                  ])
                                ])
                              ], -1)
                            ])),
                            _: 2
                          }, 1032, ["to"]),
                          _createElementVNode("button", {
                            class: "flex items-center justify-center w-10 h-10 text-red-500 bg-white border border-red-400 rounded-lg md:w-10 focus:outline-none hover:bg-gray-100 hover:text-red-600 focus:z-10 focus:ring-4 focus:ring-gray-200",
                            type: "button",
                            "aria-label": "Delete event",
                            title: "Delete",
                            onClick: ($event: any) => (_ctx.deleteEvent(event._id))
                          }, _cache[38] || (_cache[38] = [
                            _createStaticVNode("<svg class=\"w-5 h-5\" fill=\"none\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><g id=\"SVGRepo_bgCarrier\" stroke-width=\"0\"></g><g id=\"SVGRepo_tracerCarrier\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></g><g id=\"SVGRepo_iconCarrier\"><path d=\"M4 7H20\" stroke=\"#ff5c5c\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\"></path><path d=\"M6 10L7.70141 19.3578C7.87432 20.3088 8.70258 21 9.66915 21H14.3308C15.2974 21 16.1257 20.3087 16.2986 19.3578L18 10\" stroke=\"#ff5c5c\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\"></path><path d=\"M9 5C9 3.89543 9.89543 3 11 3H13C14.1046 3 15 3.89543 15 5V7H9V5Z\" stroke=\"#ff5c5c\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\"></path></g></svg>", 1)
                          ]), 8, _hoisted_44)
                        ])
                      ])
                    ]))
                  }), 128))
                ]))
        ])
      ]),
      _createElementVNode("nav", _hoisted_45, [
        _createElementVNode("span", _hoisted_46, [
          _cache[40] || (_cache[40] = _createTextVNode(" Showing ")),
          _cache[41] || (_cache[41] = _createElementVNode("span", { class: "font-semibold text-gray-900 dark:text-white" }, "1-10", -1)),
          _cache[42] || (_cache[42] = _createTextVNode(" of ")),
          _createElementVNode("span", _hoisted_47, _toDisplayString(_ctx.filteredEvents.length), 1)
        ]),
        _cache[43] || (_cache[43] = _createElementVNode("ul", { class: "inline-flex items-stretch -space-x-px" }, [
          _createElementVNode("li", null, [
            _createElementVNode("a", {
              class: "flex items-center justify-center h-full py-1.5 px-3 ml-0 text-gray-500 bg-white rounded-l-lg border border-gray-300 hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white",
              href: "#"
            }, [
              _createElementVNode("span", { class: "sr-only" }, "Previous"),
              _createElementVNode("svg", {
                "aria-hidden": "true",
                class: "w-5 h-5",
                fill: "currentColor",
                viewbox: "0 0 20 20",
                xmlns: "http://www.w3.org/2000/svg"
              }, [
                _createElementVNode("path", {
                  "clip-rule": "evenodd",
                  d: "M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z",
                  "fill-rule": "evenodd"
                })
              ])
            ])
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("a", {
              class: "flex items-center justify-center text-sm py-2 px-3 leading-tight text-gray-500 bg-white border border-gray-300 hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white",
              href: "#"
            }, "0")
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("a", {
              "aria-current": "page",
              class: "flex items-center justify-center text-sm z-10 py-2 px-3 leading-tight text-primary-600 bg-primary-50 border border-primary-300 hover:bg-primary-100 hover:text-primary-700 dark:border-gray-700 dark:bg-gray-700 dark:text-white",
              href: "#"
            }, "1")
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("a", {
              class: "flex items-center justify-center text-sm py-2 px-3 leading-tight text-gray-500 bg-white border border-gray-300 hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white",
              href: "#"
            }, "...")
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("a", {
              class: "flex items-center justify-center text-sm py-2 px-3 leading-tight text-gray-500 bg-white border border-gray-300 hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white",
              href: "#"
            }, "1")
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("a", {
              class: "flex items-center justify-center h-full py-1.5 px-3 leading-tight text-gray-500 bg-white rounded-r-lg border border-gray-300 hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white",
              href: "#"
            }, [
              _createElementVNode("span", { class: "sr-only" }, "Next"),
              _createElementVNode("svg", {
                "aria-hidden": "true",
                class: "w-5 h-5",
                fill: "currentColor",
                viewbox: "0 0 20 20",
                xmlns: "http://www.w3.org/2000/svg"
              }, [
                _createElementVNode("path", {
                  "clip-rule": "evenodd",
                  d: "M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z",
                  "fill-rule": "evenodd"
                })
              ])
            ])
          ])
        ], -1))
      ])
    ])
  ]))
}